module.exports = __webpack_public_path__ + "fonts/FreightNeoProMedium-Regular.deb77def.otf";